import HotelProductSchema from '@/models/seo/HotelProductSchema';
import ProductSchema from '@/models/seo/ProductSchema';
import ProductTypesEnum from '@/models/ProductTypesEnum';

/**
 * @function
 * @param {Object} product
 * @param {ProductTypesEnum} productCategory
 * @return { HotelProductSchema | ProductSchema }
 */
export default function (product, productCategory) {
    if ([ProductTypesEnum.DIRECT_BOOKING, ProductTypesEnum.HOTEL_VOUCHER].includes(productCategory)) {
        return new HotelProductSchema(product.productDetails, product.hotelDetails);
    }

    return new ProductSchema(product.voucherDetails);
}
